import React, { FC } from "react";
import { Xapi } from "../types/xapi";
import useTracking from "../hooks/useTracking";

function withTelemetry<T extends object>(
  WrappedComponent: FC<T>
): React.FC<T & { statements?: Xapi[] }> {
  const WithTelemetry: FC<T & { statements?: Xapi[] }> = (props) => {
    const [track] = useTracking<T>();

    const customEventHandlers: any = {};
    const xapiStatements = props.statements;
    xapiStatements?.forEach(({ eventName, ...rest }) => {
      customEventHandlers[eventName] = (...args: any) => {
        console.log(
          "About to execute telemetry event: " + eventName.toString()
        );
        track(eventName, { eventName, ...rest });
        const updatedEventName: string = eventName as string;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if (typeof props[updatedEventName] === "function") {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          (props[updatedEventName] as any)(...args);
        }
      };
    });

    return <WrappedComponent {...props} {...customEventHandlers} />;
  };

  return WithTelemetry;
}

export default withTelemetry;

/*
                  statements={[
                    {
                      eventName: 'onChange',
                      verb: {
                        display: {
                          "en-US": "en-US"
                        },
                        id: "ACCEPTED",
                      },
                      object: {
                        id: "f",
                        objectType: "CALENDAR_GLOBAL",
                        extensions: {
                          accessedForm: "d",
                          parentType: "ff"
                        }
                      }

                    }
                  ]}
*/
